<!--
 * @Date: 2022-07-04 09:34:54
 * @LastEditors: chuhongguang
-->
<template>
  <router-view/>
</template>

<script>
import { useStore } from 'vuex'
import { defineComponent, getCurrentInstance, onMounted } from 'vue';

export default defineComponent({
  setup() {
    const store = useStore()
    const { ctx } = getCurrentInstance()


    onMounted(() => {
      ctx.$i18n.locale = store.state.lang.langType
    })
  },
})
</script>